import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          {aboutData.title}
        </h2>
        <div className="space-y-4">
          {aboutData.paragraphs.map((p, idx) => (
            <p key={idx} className="text-sm md:text-base text-foreground-700 leading-relaxed">{p}</p>
          ))}
        </div>
      </div>
    </section>
  );
}